import { AccordionProps } from "./types"
import React from "react"
import useNavigation from "~hooks/useNavigation"
import Icon from "~widgets/icon"
import styled from '~/ui/styled'

const ViewRow = styled.View`
  flex-wrap: wrap;
  background-color: #fff;
  flex-direction: row;
  align-items: center;
  padding: ${({ theme }) => theme.space.md};
  margin-bottom: 1px;
  min-height: 55px;
`

const TouchableOpacityRow = styled.TouchableOpacity`
  flex-wrap: wrap;
  background-color: #fff;
  flex-direction: row;
  align-items: center;
  padding: ${({ theme }) => theme.space.md};
  margin-bottom: 1px;
  min-height: 55px;
`

const Label = styled.Text<{ color: string }>`
  color: ${({ color }) => color || "#000"};
  font-size: 16px;
  margin-right: auto;
`

const RightArea = styled.View`
  min-width: 30px;
`
const Accordion: React.FC<AccordionProps> = ({
  style = {},
  labelColor,
  label,
  to,
  disabled,
  onClick,
  hideRightArea = true,
  hasRightIcon,
  children,
}) => {
  const navigation = useNavigation()
  const Wrapper = !disabled && (onClick || to) ? TouchableOpacityRow : ViewRow
  return (
    <Wrapper
      style={style}
      onClick={() => {
        if (onClick) {
          onClick()
        } else if (to) {
          navigation.push(to)
        }
      }}
      activeOpacity={disabled ? 1 : 0.2}
    >
      {label && <Label color={labelColor}>{label}</Label>}
      {children}
      {hideRightArea && (
        <RightArea>{hasRightIcon && <Icon name="right" color="#999" size={20} />}</RightArea>
      )}
    </Wrapper>
  )
}
export default Accordion
